module.exports = settings;